// extracted by mini-css-extract-plugin
export default {"mainTabs":"TabsViewer_mainTabs_pQOEz","tabs":"TabsViewer_tabs_stA_S","tab":"TabsViewer_tab_Egwa8","tabActive":"TabsViewer_tabActive_b6wFU","content":"TabsViewer_content_WOpHF"};